import { jsx as t, jsxs as s } from "react/jsx-runtime";
import { useTranslation as v, Trans as b } from "react-i18next";
import C from "classnames";
import f from "../../../components/Button/index.js";
import g from "../../../icons/Upload.js";
const I = "data:image/svg+xml,%3csvg%20width='51'%20height='64'%20viewBox='0%200%2051%2064'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0.119141%202.57388C0.119141%201.34734%201.11344%200.353021%202.33999%200.353004L35.5538%200.352539L50.882%2014.9835V61.4271C50.882%2062.6537%2049.8877%2063.648%2048.6611%2063.648H2.34002C1.11346%2063.648%200.119141%2062.6537%200.119141%2061.4271V2.57388Z'%20fill='%23D5EDD5'/%3e%3cpath%20d='M19%2032H31M25%2026V38'%20stroke='%2379BE70'%20stroke-width='2.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", N = "data:image/svg+xml,%3csvg%20width='53'%20height='66'%20viewBox='0%200%2053%2066'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.11914%203.57388C1.11914%202.34734%202.11344%201.35302%203.33999%201.353L36.5538%201.35254L51.882%2015.9835V62.4271C51.882%2063.6537%2050.8877%2064.648%2049.6611%2064.648H3.34002C2.11346%2064.648%201.11914%2063.6537%201.11914%2062.4271V3.57388Z'%20stroke='%2379BE70'%20stroke-width='2'%20stroke-linecap='round'%20stroke-dasharray='6%206'/%3e%3c/svg%3e", x = "data:image/svg+xml,%3csvg%20width='51'%20height='64'%20viewBox='0%200%2051%2064'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0.119141%202.57388C0.119141%201.34734%201.11344%200.353021%202.33999%200.353004L35.5538%200.352539L50.882%2014.9835V61.4271C50.882%2062.6537%2049.8877%2063.648%2048.6611%2063.648H2.34002C1.11346%2063.648%200.119141%2062.6537%200.119141%2061.4271V2.57388Z'%20fill='%23FFDADA'/%3e%3cpath%20d='M19%2037.9999L30.9999%2026M19%2026.0001L30.9999%2038'%20stroke='%23F36578'%20stroke-width='2.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", z = "forma-ui__file-dropzone-content__acceptIcon", F = "forma-ui__file-dropzone-content__acceptFormat", L = "forma-ui__file-dropzone-content__title", M = "forma-ui__file-dropzone-content__placeholder", j = "forma-ui__file-dropzone-content__content", V = "forma-ui__file-dropzone-content__button", B = "forma-ui__file-dropzone-content__buttonIcon", D = "forma-ui__file-dropzone-content__link", H = "forma-ui__file-dropzone-content__buttons", o = {
  acceptIcon: z,
  acceptFormat: F,
  title: L,
  placeholder: M,
  content: j,
  button: V,
  buttonIcon: B,
  link: D,
  buttons: H
}, r = ({ children: e, className: n }) => /* @__PURE__ */ t("div", { className: C(o.content, n), children: e }), h = ({ accept: e, maxSize: n }) => {
  const { t: l } = v(), a = e && Object.values(e).flat().join(" " + l("uikit:or") + " ");
  return /* @__PURE__ */ s("div", { className: o.acceptFormat, children: [
    a && a + " ",
    l("uikit:up_to_mb", { value: Math.ceil(n / 1024 / 1024) })
  ] });
}, A = ({
  isPhone: e,
  isHovered: n,
  isDragAccept: l,
  isDragReject: a,
  title: m,
  placeholder: w,
  maxSize: d,
  maxFiles: k,
  accept: u,
  onClickAdd: p,
  className: c
}) => {
  const { t: _ } = v();
  return e ? /* @__PURE__ */ t(r, { className: c, children: /* @__PURE__ */ t("div", { className: o.buttons, children: /* @__PURE__ */ t(
    f,
    {
      className: o.button,
      size: "small",
      onClick: (i) => {
        i.stopPropagation(), p();
      },
      icon: /* @__PURE__ */ t(g, {}),
      iconClassName: o.buttonIcon,
      fullWidth: !0,
      reversed: !0,
      children: _("uikit:upload")
    }
  ) }) }) : a ? /* @__PURE__ */ s(r, { className: c, children: [
    /* @__PURE__ */ t("img", { src: x, className: o.acceptIcon, width: "54", height: "66", alt: "" }),
    /* @__PURE__ */ t(h, { accept: u, maxSize: d })
  ] }) : l ? /* @__PURE__ */ s(r, { className: c, children: [
    /* @__PURE__ */ t("img", { src: I, className: o.acceptIcon, width: "54", height: "66", alt: "" }),
    /* @__PURE__ */ t(h, { accept: u, maxSize: d })
  ] }) : n ? /* @__PURE__ */ s(r, { className: c, children: [
    /* @__PURE__ */ t("img", { src: N, className: o.acceptIcon, width: "54", height: "66", alt: "" }),
    /* @__PURE__ */ t(h, { accept: u, maxSize: d }),
    /* @__PURE__ */ t("div", { className: o.buttons, children: /* @__PURE__ */ t(
      f,
      {
        className: o.button,
        size: "small",
        onClick: (i) => {
          i.stopPropagation(), p();
        },
        icon: /* @__PURE__ */ t(g, {}),
        iconClassName: o.buttonIcon,
        reversed: !0,
        children: _("uikit:upload")
      }
    ) })
  ] }) : /* @__PURE__ */ s(r, { className: c, children: [
    m && /* @__PURE__ */ t("div", { className: o.title, children: m }),
    /* @__PURE__ */ t("div", { className: o.placeholder, children: w ?? /* @__PURE__ */ t(
      b,
      {
        i18nKey: "uikit:drag_file_or_select",
        components: {
          select: /* @__PURE__ */ t("span", { className: o.link, onClick: (i) => {
            i.stopPropagation(), p();
          } })
        },
        count: k
      }
    ) })
  ] });
};
export {
  A as default
};
